<template>
  <Layout v-if="type === 'admin'">
      <div>
      <div class="bg-white">
      <div class=" mx-auto sm:px-6  lg:px-6 lg:flex lg:items-center lg:justify-between">
          <div class="flex-shrink-0 h-24 w-24">
          <img
            class="h-24 w-24 rounded-full"
            src="../assets/GraceNew.png"
            alt=""
            />
          </div>
           <!-- <button 
          type="button"
          v-on:click="createArray(); updateSermon();"
          class="relative inline-flex items-center px-5 py-4 border border-transparent text-sm font-medium rounded-md text-blue-600 bg-white hover:text-red-600 focus:outline-none transition duration-150 ease-in-out"
          >
          <img class="h-6 w-6" src="../assets/save.png" alt />
          <a  class="absolute inset-0 z-6 bg-white text-center flex flex-col items-center justify-center opacity-0 hover:opacity-50 bg-opacity-80 duration-300">
         <h1 class=tracking-wider >Update Sermon</h1>
          </a>
        </button>-->
          <h2  class="text-xl leading-9 font-extrabold tracking-tight text-black sm:text-xl md:text-2xl lg:text-2xl sm:leading-10 justify-start text-left">
             Sermon ID : <a style="color: #C38437" class="text-2xl font-extrabold text-blue-700 sm:text-xl md:text-2xl lg:text-2xl justify-start text-left">{{ admin.sermonID}}</a>
            <br />
          </h2>
         
          <h2 class="text-xl leading-9 font-extrabold tracking-tight text-black sm:text-xl md:text-2xl lg:text-2xl sm:leading-10 justify-start text-left">
           Sermon Date: <a style="color: #C38437" class="text-2xl font-extrabold text-blue-700 sm:text-xl md:text-2xl lg:text-2xl justify-start text-left">{{ (admin.entryDate) }}</a>
            <br />
          </h2>
        </div>
      </div>
    </div>
    {{errorMessage}}
        <div class="text-xl text-left text-black">
    <p v-if="errors.length">
      <b></b>
      <ul>
        <div class="text-red-600 text-left">
        <li v-for="error in errors" :key=error>{{ error }}</li>
        </div>
      </ul>
    </p>
    </div>
    <div
      class="bg-white shadow overflow-hidden sm:rounded-lg mt-2"
      v-if="admin"
    >
      <div style="background-color: #C38437" class="px-4 py-2 border-b bg-yellow-600 border-gray-200 sm:px-6">
        <h3 class="text-xl leading-6 font-medium text-gray-900">
          <p style="color: #005482" class="mt-1 max-w-2xl text-xl leading-5 text-gray-500">
           
          </p>
        </h3>
      </div>
      <div>
        <dl>
            <div
            class="bg-gray-50 px-4 pt-2 py-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
           Pastor :
            </dt>
            <dd
              class="mt-1 text-sm leading-5 text-blue-600 sm:mt-0 sm:col-span-2"
            >
              <textarea maxlength="200" v-model="admin.Pastor" class ="resize-none appearance-none block w-full bg-gray-50 text-black rounded py-3 px-4 leading-tight focus:outline-none bg-gray-200 focus:border-gray-500 h-12" id="Name" placeholder="Name..."></textarea>
            </dd>
          </div>
              <div
            class="bg-gray-50 px-4 pt-0 py-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
           Entry Date :
            </dt>
            <dd
              class="mt-0 text-sm leading-5 text-blue-600 sm:mt-0 sm:col-span-2"
            >
              <BaseInput label="" type="date"  placeholder="..." v-model="admin.entryDate" />
            </dd>
          </div>
          <div
            class="bg-gray-50 px-4 pt-0 py-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
           Entry Time :
            </dt>
            <dd
              class="mt-0 text-sm leading-5 text-blue-600 sm:mt-0 sm:col-span-2"
            >
              <BaseInput label="" type="time"  placeholder="..." v-model="admin.entryTime" />
            </dd>
          </div>
        
          <div
            class="bg-gray-50 px-4 pt-2 py-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
            Sermon Text :
            </dt>
            <dd
              class="mt-1 text-sm leading-5 text-blue-600 sm:mt-0 sm:col-span-2"
            >
              <textarea maxlength="200" v-model="admin.text" class ="resize-none appearance-none block w-full bg-gray-50 text-black rounded py-3 px-4 leading-tight focus:outline-none bg-gray-200 focus:border-gray-500 h-12" id="Name" placeholder="Name..."></textarea>
            </dd>
          </div>
          <div
            class="bg-gray-50 px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
           Sermon Name :
            </dt>
       
            <dd
              class="mt-1 text-sm leading-5 text-blue-600 sm:mt-0 sm:col-span-2"
            >
         
              <textarea maxlength="300"  v-model="admin.sermonName" class ="resize-none appearance-none block w-full h-20 bg-gray-50 text-black rounded py-3 px-4 leading-tight focus:outline-none bg-gray-200 focus:border-gray-500 h-12" id="Name" placeholder="Name..."></textarea>
            </dd>
          </div>
          <div v-if="admin.taskStatus"
            class="bg-gray-50 px-4 pt-2 py-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
            Task Owner :
            </dt>
            <dd
              class="mt-1 text-sm leading-5 text-black sm:mt-0 sm:col-span-2"
            >
             {{admin.entryOwner}}
            </dd>
          </div>
          <div v-if="admin.taskStatus"
            class="bg-gray-50 px-4 pt-2 py-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
            Task Added By :
            </dt>
            <dd
              class="mt-1 text-sm leading-5 text-black sm:mt-0 sm:col-span-2"
            >
             {{admin.addedBy}}
            </dd>
          </div>
          <div v-if="admin.dateUpdated"
            class="bg-gray-50 px-4 pt-2 py-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
            Updated By:
            </dt>
            <dd
              class="mt-1 text-sm leading-5 text-black sm:mt-0 sm:col-span-2"
            >
             {{admin.updatedBy}}
            </dd>
          </div>
          <div v-if="admin.dateUpdated"
            class="bg-gray-50 px-4 pt-2 py-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
            Updated Date :
            </dt>
            <dd
              class="mt-1 text-sm leading-5 text-black sm:mt-0 sm:col-span-2"
            >
            {{  
            new Date(admin.dateUpdated).toLocaleDateString()
             }} 
            </dd>
          </div>
          <div v-if="admin.dateClosed"
            class="bg-gray-50 px-4 pt-2 py-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
            Closed By :
            </dt>
            <dd
              class="mt-1 text-sm leading-5 text-black sm:mt-0 sm:col-span-2"
            >
            {{  
            (admin.closedBy)
             }} 
            </dd>
          </div>
          <div v-if="admin.dateClosed"
            class="bg-gray-50 px-4 pt-2 py-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
            Closed Date :
            </dt>
            <dd
              class="mt-1 text-sm leading-5 text-red-600 sm:mt-0 sm:col-span-2"
            >
            {{  
            new Date(admin.dateClosed).toLocaleDateString()
             }} 
            </dd>
          </div>
        
         <div class="pl-4 ml-2 pt-2 bg-gray-50"></div>
            <BaseButton v-on:click="createArray(); checkForm(); updateSermon();"  >Update Sermon Text</BaseButton>
         <!-- <div v-if="admin.document"
            class="bg-gray-50 px-4 py-0 pt-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
              Email Manual
            </dt>
            <dd
              class="py-3 px-4 mt-1 text-lg leading-5 text-orange-600 sm:mt-0 sm:col-span-2"
            >
            <input type="email" class="w-80 h-8" id="email" name="user_email" v-model="email" placeholder="Your email.." required>
            <input type="submit" value="Send Now" class=" inline-flex text-xl items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-blue-600 hover:bg-blue-900 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-700 active:bg-blue-600 transition duration-150 ease-in-out">
            </dd>
          </div> -->
          <div>

       </div>
          <div class="pl-10"></div>
        </dl>
      </div>
    </div>

        <div
      class="bg-white shadow overflow-hidden sm:rounded-lg mt-2"
      v-if="admin"
    >

      <div>
        <dl>
            <div
            class="bg-gray-50 px-4 pt-2 py-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
           Sermon Youtube Link :
            </dt>
            <dd
              class="mt-1 text-sm leading-5 text-blue-600 sm:mt-0 sm:col-span-2"
            >
              <textarea maxlength="2000" v-model="sermonLink.document" class ="resize-none appearance-none block w-full bg-gray-50 text-black rounded py-3 px-4 leading-tight focus:outline-none bg-gray-200 focus:border-gray-500 h-40" id="Name" placeholder="Name..."></textarea>
            </dd>
          </div>
            <div class="pl-4 ml-2 pt-2 bg-gray-50"></div>
            <BaseButton v-on:click="updateSermonLink(); "  >Update Sermon Link</BaseButton>
       
          <div class="pl-4 bg-gray-50"></div>
        </dl>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "./layouts/Main.vue";
//import BaseFileUploader from "../components/BaseFileUploader";
//import BaseFileUploader from "../components/BaseFileUploader";
import BaseButton from "../components/BaseButton";
import BaseInput from "../components/BaseInput";
//import emailjs from 'emailjs-com';
import { mapGetters } from "vuex";

export default {
  name: "adminsermonview",
  components: { Layout, BaseButton, BaseInput},
  data() {
    return {
      admin: {},
      businessPartner: "",
      //fileUrl: "",
      array : "",
      sermonLink: "",
      timer100: "",
      errors: [],
     

    };
  },
  created() {
    this.type = this.currentUserData.userType;
    this.userStatus = this.currentUserData.status;
    if (this.type !== "admin" ) {
      this.$router.push({
        name: "home",
      });
    }
    this.getSermonData();
    
    //this.getSermonID();
    //this.getEmployeeCertificate();
    
  },
  mounted(){

    //this.getLicenseData();

  },
  computed: {
    ...mapGetters(["currentUserData"]),
  },
  methods: {
    getSermonData() {
      const employeeRef = this.$db
        .collection("sermons")
        .doc(this.$route.params.id);

      employeeRef.get().then((doc) => {
        this.admin = doc.data();
      });
      this.timer100 = setTimeout(this.getSermonID, 1000)
    },
    getSermonID() {
      //const employer = [];
      const certData = this.$db
        .collection("sermonLinks")
        .where("sermonID", "==", this.admin.sermonID)
        
        
      certData.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const data = {
            id: doc.id,
            ...doc.data(),
          };
          this.sermonLink = data;
        });
        //this.removeTicket();
        //this.deleteAttachPlanning();
      });
    },
    createArray(){
      if(!this.array)
      this.array = []

      for (let i = 0; i < this.admin.sermonName.length; i++){
      this.array.push(this.admin.sermonName.slice(0,i+1).toLowerCase());
      }
    },

  
    updateSermon() {
      this.$db
        .collection("sermons")
        .doc(this.$route.params.id)
        .update({
          //clientName: this.company.clientName.toLowerCase(),
          Pastor: this.admin.Pastor,
          text: this.admin.text,
           search: this.array,
           entryDate: this.admin.entryDate,
           entryTime: this.admin.entryTime,
           searchDate : this.admin.entryDate,
           sermonName : this.admin.sermonName,
          updatedBy: this.currentUserData.email,
          //clientID: this.company.address,
        });
      //this.pages.homeJobSeeker = this.homeJobSeeker,
      window.confirm("Sermon Has been updated.");
       this.redirect();
    },
      checkForm: function (e) {
      this.errors = [];

       
        if (!this.admin.Pastor) {
          this.errors.push("Pastor is required...");
        }
        if (!this.admin.entryDate) {
          this.errors.push("Date is required...");
        }
        if (!this.admin.entryTime) {
          this.errors.push("Time is required...");
        }
        if (!this.admin.sermonName) {
          this.errors.push("Sermon Name is required...");
        }
        if (!this.admin.text) {
          this.errors.push("Sermon Text is required...");
        }
        if (!this.errors.length) {
          return true;
        }

        e.preventDefault();
      },
    updateSermonLink() {
      this.$db
        .collection("sermonLinks")
        .doc(this.sermonLink.id)
        .update({
          //clientName: this.company.clientName.toLowerCase(),
         document: this.sermonLink.document,
        
        });
      //this.pages.homeJobSeeker = this.homeJobSeeker,
      window.confirm("Sermon Link Has been updated.");
       this.timer100 = setTimeout(this.getSermonID, 1000)
    },


    redirect(){
      this.$router.back();
    }


  }
};
</script>
